import { render, staticRenderFns } from "./PotentialDuplicateModal.vue?vue&type=template&id=5f445c69"
import script from "./PotentialDuplicateModal.vue?vue&type=script&lang=ts"
export * from "./PotentialDuplicateModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/components/livingDonors/_locales/PotentialDuplicateModal.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2FlivingDonors%2FPotentialDuplicateModal.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports